import { Form, FormInstance, Input, Select } from "antd";
import SelectDropdownLgIcon from "../../../assets/icons/SelectDropdownLgIcon";
import { selectSearchOption } from "../../../utils/utils";

type Props = {
  form: FormInstance<any>;
};

export default function AddressOrganization({ form }: Props) {
  return (
    <div>
      <Form.Item
        name="business_role_id"
        label="Division"
        className="mb-4"
        rules={[
          {
            required: true,
            message: "Please select division",
          },
        ]}
      >
        <Select
          placeholder="Select"
          size="large"
          allowClear
          showSearch
          filterOption={selectSearchOption}
          options={[{ label: "Pabna", value: "pabna" }]}
          suffixIcon={<SelectDropdownLgIcon />}
          //   disabled={!departmentId}
        />
      </Form.Item>
      <Form.Item
        name="business_role_id2"
        label="District"
        className="mb-4"
        rules={[
          {
            required: true,
            message: "Please select district",
          },
        ]}
      >
        <Select
          placeholder="Select"
          size="large"
          allowClear
          showSearch
          filterOption={selectSearchOption}
          options={[{ label: "Pabna", value: "pabna" }]}
          suffixIcon={<SelectDropdownLgIcon />}
          //   disabled={!departmentId}
        />
      </Form.Item>
      <Form.Item
        name="Postal Code"
        label="Postal Code"
        className="mb-4"
        rules={[
          {
            required: true,
            message: "Please enter postal code",
          },
        ]}
      >
        <Input size="large" placeholder="Postal Code" />
      </Form.Item>
      <Form.Item
        name="Full address"
        label="Full address"
        className="mb-1"
        rules={[
          {
            required: true,
            message: "Please enter full address",
          },
        ]}
      >
        <Input size="large" placeholder="Select thana/upazila" />
      </Form.Item>
    </div>
  );
}
